import React, { useState, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DropdownRight from "./DropdownRight";
import HeaderLeft from "./HeaderLeft";
import { useDispatch } from "react-redux";
import { setVideo } from "../store/auth/video";
import { setInput } from "../store/auth/inputvalue";
import { setFiles, setID } from "../store/auth/video";

function UploadYourWorkHere() {
  const location = useLocation();
  const { id, camera } = location.state || {};

  const dispatch = useDispatch();
  const [file, setFile] = useState({});
  const inputFileRef = useRef(null);
  const navigate = useNavigate();
  const [inputText, setInputText] = useState("");
  dispatch(setID(id));

  const onVideoChange = (event) => {
    console.log("video==>", event.target.files[0]);
    setFile(event.target.files[0]);
    let img = event.target.files[0];
    dispatch(setFiles(img));

    const videoToshow = URL.createObjectURL(img);
    console.log("image==>", videoToshow);

    dispatch(setVideo(videoToshow));
    navigate("/areYouSureUpload", { state: { camera } });
  };

  const handleChange = (e) => {
    console.log("input value", e.target.value);
    dispatch(setInput(e.target.value));
  };

  return (
    <>
      <header>
        <div class="custom_container ">
          <HeaderLeft />
          <div class="user_profile">
            <DropdownRight />
          </div>
        </div>
      </header>

      <section class="otp_verification custom_hight">
        <div class="login_inner">
          <h1 class="mb_30 main_title ">Upload your work here</h1>
          <p class="mb_40 them_para text-center mx-auto text_limit">
            Browse a video clip from your files and upload here before delivery
            time etc.
          </p>
          <div>
            <input
              type="text"
              name="file_name"
              placeholder="File name"
              className="form-control"
              style={{ width: "30%", borderRadius: 30 }}
              onChange={handleChange}
            />
          </div>
          <div class="wraper_btn">
            {/*  <Link to="/areYouSureUpload">
              <button type="button" class="them_btn_ouline ml-3   ">
                Browse
              </button>
            </Link> */}
            <div class="upload-btn-wrapper btn_wraper">
              <button class="them_btn_ouline ml-3">Browse</button>
              <input
                type="file"
                name="myfile"
                ref={inputFileRef}
                onChange={onVideoChange}
              />{" "}
            </div>
            <Link to="/work">
              <button type="button" class="them_btn_ouline ml-3">
                Go Back
              </button>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export default UploadYourWorkHere;
